module.exports = __webpack_public_path__ + "static/tennis_play-debc77e3a3c397aa869c4e37ad4bdafc.gif";